import moment from 'moment';
import { MIN_AGE } from '../conf/user';
import { Role, RoleExplained } from './role';
import { UserTerm } from './term';

export const RELEASE_NOTES_VIEW: number = 2;
export const RELEASE_PRIVACY_NOTES_VIEW: number = 1;

export class User {
	Id?: number;
	Username = '';
	FirstName = '';
	LastName = '';
	Adult = true;
	BirthDate?: Date;
	Email = '';
	Phone = '';
	CountryName = '';
	Language = 'it-IT';
	CompanyName? = '';
	TechnicianCode?: string;
	AssignedTechnician?: boolean;
	Password?: string;
	HeadQuarterId?: number;
	Roles?: Role[] = [];
	Role?: string;
	UserTerms: UserTerm[] = [];
	PersonifiedId?: number;
	EmailConfirmed?: boolean;
	BetaFe?: number;
	JumpFe: number;
	ThemeFe?: string;
	PrecLoginFe?: Date;
	ReleaseVersion?: string;
	PrivacyVersion?: string;
	InvitationToken?: string;
	MfaEnabled?: boolean;
	MfaMode?: boolean;
}

export const maxRegistrationDate = (): Date => {
	const year = new Date().getFullYear() - MIN_AGE;
	return new Date(new Date().setFullYear(year));
};

export const lastLoginIsToday = (user: User): boolean => {
	if (user === undefined || user === null) {
		return true; // user don't exist -> no update to db needed
	} else if (user.PrecLoginFe === undefined || user.PrecLoginFe === null) {
		return false; // user exist and i have no record of lastLogin -> i need to update db
	} else {
		let currentDate = new Date().toUTCString();
		currentDate = moment(currentDate).format('YYYY-MM-DD')
		const lastLogin = moment(user.PrecLoginFe).format('YYYY-MM-DD');
		return currentDate === lastLogin;
	}
};

export const currentRole = (user: User): RoleExplained => {
    if (!Array.isArray(user.Roles) && !user.Roles[0]) {
        return {};
    }
    const role = user.Roles[0].Description;
    switch (role) {
        case 'USER':
            return { isUser: true };
        case 'TECHNICIAN':
            return { isTechnician: true };
        case 'SERVICE':
            return { isService: true };
        case 'SUBSIDIARY':
            return { isSubsidiary: true };
        case 'ADMIN':
            return { isAdmin: true };
        case 'MARKETING':
            return { isMarketing: true };
        case 'SWUPD-ADMIN':
            return { isFirmTech: true };
        default:
            return { isUser: true };
    }
};
